<script>
  export let show = true;
  import { slide } from 'svelte/transition';
</script>

<style>
  .intro {
    border-bottom: 1px dashed #9D9D9D;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
  }
</style>

{#if show}
<div class="intro" transition:slide>
  <p>تشرين الأول/أكتوبر 2020</p>
  <p> مصفوفة اليمن هي أداة تفاعلية تغطي العلاقات بين الجهات الفاعلة الأساسية المشاركة في النزاعات المختلفة في البلاد. يمكن للمستخدمين البحث حسب الجهات الفاعلة أو العلاقة، وتحدد الرموز كل علاقة على طول النطاق من حليف إلى خصم، مصحوبة بشرح موجز وأحداث ذات صلة متاحة. تتضمن كل صفحة من صفحات الجهات الفاعلة ملف تعريفي موجز وخريطة، كما تتضمن كل مجموعة أيضًا قائمة مختارة من الأعضاء.</p>
  <p dir="rtl"> لقراءة البحث بأكمله، قم بتنزيل ملف الـ <a target="_blank" href="https://www.washingtoninstitute.org/media/4376">پي. دي. إف</a></p>
  <div class="hide-for-desktop">
    <p><em>يفضل البحث في الأداة التفاعلية على الحاسوب</em></p>
  </div>
</div>
{/if}
